import { Checkbox } from '@deliveryhero/pd-cookbook/components/Checkbox';
import { Grid } from '@mui/material';

import { FormikProps } from 'formik';

import { AllowanceValuesType } from '../AllowanceDetailForm';
import { AllowancePaddedPaper as PaddedPaper } from './AllowancePaddedPaper';

export const SetRequireExpenseCode = ({
  values,
  setFieldValue
}: FormikProps<AllowanceValuesType>) => {
  return (
    <Grid item>
      <PaddedPaper disabled={!values.editable}>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <Checkbox
              id="expense_code_checkbox"
              label="Requires expense code"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue(
                  'expense_code_required_in_checkout',
                  event.target.checked
                );
              }}
              disabled={!values.editable}
            />
          </Grid>
        </Grid>
      </PaddedPaper>
    </Grid>
  );
};
